import { Link } from 'react-router-dom';
import { extensions, extensionUrl } from '../registry';
import { defaultConfig } from '../lib/extension';

/** Self-documenting landing page: what is deployed here, at which URL, with which config. */
export function IndexPage() {
  const host = `${window.location.origin}${window.location.pathname}`;
  return (
    <div className="vc-page">
      <h1>Contentstack extensions</h1>
      <p className="vc-muted">build {__BUILD_SHA__} · {__BUILD_TIME__}</p>
      <table>
        <thead>
          <tr><th>Extension</th><th>Location</th><th>Owner</th><th>Default config</th><th>URL for the stack</th></tr>
        </thead>
        <tbody>
          {extensions.map(({ meta }) => (
            <tr key={meta.id}>
              <td>
                <strong>{meta.title}</strong><br />
                <span className="vc-muted">{meta.description}</span><br />
                <Link to={`/dev/${meta.id}`}>open in dev harness</Link>
              </td>
              <td>{meta.location}{meta.dataType ? ` (${meta.dataType}${meta.multiple ? '[]' : ''})` : ''}</td>
              <td>{meta.owner}</td>
              <td><pre>{JSON.stringify(defaultConfig(meta), null, 2)}</pre></td>
              <td><code>{extensionUrl(host, meta.id)}</code></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
